// extracted by mini-css-extract-plugin
export default {"wizard":"itineraryAdmin_wizard__1zCZm"};